<template>
  <LoadingDiv v-if="isLoading" />

  <div class="vetting-workbench sba-slide-in" v-else>
    <template v-if="encounter">
      <div class="card z-depth-0 vetting-soft-core" :class="{ 'vetting-soft-core-add-open': adder && clusterStatus != 'v' && clusterStatus != 'r' }">
        <!-- Bio -->
        <div class="card-panel z-depth-0 grey lighten-5 vetting-soft-bio" :class="{ 'red lighten-5': encounter.status == 'd' }">
          <div class="row">
            <div class="col s12 m1 grey lighten-4 vetting-soft-count">
              <span class="chip light-blue lighten-5 center"><b>{{ curr }}/{{ total }}</b></span>
            </div>
              <br class="hide-on-med-and-up" />
              <br class="hide-on-med-and-up" />
            <div class="col s8 m7">
              <p>{{ capWords(encounter.client_name) }}</p>
              <h5>{{ capWords(encounter.name) }} ({{ encounter.enrollee_number }})</h5>

              <span v-if="encounter?.encounter_date">
                <p>
                  <span class="orange-text text-darken-4">
                    {{
                      new Date(encounter?.encounter_date).toLocaleString(undefined, {
                        year: "numeric",
                        month: "short",
                        day: "numeric",
                      })
                    }}
                  </span>
                  ->
                  <span class="teal-text text-darken-4" v-if="encounter?.encounter_date_end">
                    {{
                      new Date(encounter?.encounter_date_end).toLocaleString(undefined, {
                        year: "numeric",
                        month: "short",
                        day: "numeric",
                      })
                    }}
                  </span>
                </p>
              </span>
              <span v-else>
                <p>Encounter Dates <em>not</em> set</p>
              </span>

            </div>
            <div class="col s4">
              <img :src="encounter.profile_img" width="96" class="circle responsive-img right"
                v-if="encounter.profile_img" />
              <img :src="`https://ui-avatars.com/api/?name=${encounter.name}&size=128`" width="96"
                class="circle responsive-img right" v-else />
            </div>
          </div>

          <!-- Show flag -->
          <template v-if="encounter?.compliance_flag == 'y'">
            <div class="card-content spacer10">
              <div class="row yellow lighten-5 vetting-soft-flag">
                <div class="col s12 spacer10">
                  <label class="active orange-text darken-text-2"><i class="tiny material-icons">flag </i> Compliance
                    Flagged</label>
                  <p>Kindly review claim for re-approval.</p>
                  <br />
                </div>
              </div>
            </div>
          </template>
        </div>

        <!-- Display Diagnosis -->
        <div id="display" class="row teal lighten-5 vetting-soft-diagnosis">
          <div class="col s12">
            <div class="card-content yellow lighten-1">
              <span class="collections black-text">
                <h6>
                  <i class="tiny material-icons">bookmark_border</i>
                  Diagnosis: {{ (encounter.diagnosis || "NOT RECORDED").toUpperCase() }}
                </h6>
              </span>
            </div>
          </div>
        </div>

        <!-- Claims Display Card -->
        <div class="card vetting-soft-claims">

          <!-- Add -->
          <div class="vetting-soft-add-panel" v-if="adder && clusterStatus != 'v' && clusterStatus != 'r'">
            <AddClaimItem :turl="{ sid: forTariff?.scheme_id, pid: forTariff?.provider_id }" :reset="error" @update="handleAddClaimUpdate" />
          </div>

          <!-- Show -->
          <div class="card-content">

            <span class="card-title">Claims
              <span class="secondary-content chip clickable vetting-soft-add"
                :class="{ 'teal lighten-5 teal-text': !adder, 'orange lighten-5 orange-text': adder }"
                :title="adder ? 'close' : 'Add New Claim'"
                @click.prevent="handleAddClaim"
                v-if="clusterStatus != 'v' && clusterStatus != 'r'">
                <i class="material-icons">{{ adder ? 'close' : 'add_circle' }}</i>
              </span>
            </span>

            <!-- List claims -->
            <ol id="item-list" class="collection vetting-soft-list">
              <li class="collection-item claim-line-item" v-for="claim in encounter.claims" :key="claim.id">
                <template v-if="encounter.status == 'd'">

                  <!-- Deleted Encounter Items -->
                  <span class="claim-line-copy">
                    <s>{{ capWords(claim.item) }} x {{ claim.sent_qty }} (Amount Sent: ₦{{
                      Number(claim.sent_price)
                        .toFixed(2)
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }})</s>
                    <b><span v-if="hasClaimComment(claim)" class="info-item tooltipped pointable" data-position="top" :data-tooltip="claim.comment">
                        <i class="material-icons grey-text">help</i>
                      </span></b>

                    <!-- Authorizations (delete) -->
                    <span v-if="claim.authorization == 'y'">
                      => <s> ({{ claim.authorization_code }}) </s>
                    </span>
                  </span>

                </template>

                <template v-else>
                  <!-- Approved Items -->
                  <span class="claim-line-copy" v-if="claim.status == 'a'">
                    <b>{{ capWords(claim.item) }}</b> x {{ claim.sent_qty }} (₦{{
                      Number(claim.sent_price)
                        .toFixed(2)
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }})

                    <!-- Reviewed claim -->
                    <span class="brown-text" v-if="hasClaimVettingAdjustment(claim)">
                      <b> =></b>

                      <span v-if="claim.sent_qty != claim.approved_qty"> x {{ claim.approved_qty }} </span>

                      <b> (₦{{
                        Number(claim.approved_price)
                          .toFixed(2)
                          .toString()
                          .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                      }})<span v-if="hasClaimComment(claim)" class="info-item tooltipped pointable" data-position="top"
                          :data-tooltip="capWords(claim.comment)">
                          <i class="material-icons grey-text hide-on-small-only">help</i>
                          <i class="tiny material-icons grey-text hide-on-med-and-up">help</i>
                        </span></b>
                    </span>

                    <!-- Authorizations (manual) -->
                    <span v-if="claim?.authorization_code && claim.authorization != 'y'">
                      => ({{ claim.authorization_code }})
                    </span>

                    <!-- Authorizations (active) -->
                    <span v-if="claim.authorization == 'y'">
                      => ({{ claim.authorization_code }})
                      <span class="info-item tooltipped secondary-content pointable" data-position="top"
                        :data-tooltip="claim?.slug">
                        <i class="material-icons">lock_outline</i>
                      </span>
                    </span>

                    <!-- Actions -->
                    <template v-if="clusterStatus != 'v' && clusterStatus != 'r'">
                      <span class="line-item-actions" v-if="
                        encounter.status != 'd' && claim.authorization != 'y'
                      ">
                        <a href="#" class="secondary-content cancel-item" @click.prevent="handleDelete(claim)"
                          title="decline">
                          <i class="material-icons hide-on-small-only" :class="{
                            'grey-text': deleteClaim != claim,
                            'red-text': deleteClaim == claim,
                          }">cancel</i>

                          <i class="tiny material-icons hide-on-med-and-up" :class="{
                            'grey-text': deleteClaim != claim,
                            'red-text': deleteClaim == claim,
                          }">cancel</i>
                          </a>
                        <a href="#" class="secondary-content edit-item" @click.prevent="handleEdit(claim)"
                          title="edit">
                          <i class="material-icons hide-on-small-only" :class="{
                            'grey-text': editClaim != claim,
                            'blue-text': editClaim == claim,
                          }">edit</i>

                          <i class="tiny material-icons hide-on-med-and-up" :class="{
                            'grey-text': editClaim != claim,
                            'blue-text': editClaim == claim,
                          }">edit</i>
                          </a>
                      </span>
                    </template>
                  </span>

                  <!-- Deleted Items -->
                  <span class="claim-line-copy" v-else>
                    <s>{{ capWords(claim.item) }} x {{ claim.sent_qty }} (Amount Sent: ₦{{
                      Number(claim.sent_price)
                        .toFixed(2)
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }})</s>
                    <b><span v-if="hasClaimComment(claim)" class="info-item tooltipped pointable" data-position="top"
                        :data-tooltip="capWords(claim.comment)">
                        <i class="material-icons grey-text hide-on-small-only">help</i>
                        <i class="tiny material-icons grey-text hide-on-med-and-up">help</i>
                      </span></b>

                    <!-- Authorizations (delete) -->
                    <span v-if="claim.authorization == 'y'">
                      => ({{ claim.authorization_code }})
                      <span class="info-item tooltipped secondary-content pointable" data-position="top"
                        :data-tooltip="claim.slug">
                        <i class="material-icons hide-on-small-only">lock_outline</i>
                        <i class="tiny material-icons hide-on-med-and-up">lock_outline</i>
                      </span>
                    </span>

                    <!-- Actions -->
                    <template v-if="clusterStatus != 'v' && clusterStatus != 'r'">
                      <span class="line-item-actions" v-if="
                        encounter.status != 'd' && claim.authorization != 'y'
                      ">
                        <a href="#" class="secondary-content reset-item" @click.prevent="handleReset(claim)"
                          title="reset"><i class="small material-icons grey-text">refresh</i></a>
                      </span>
                    </template>
                  </span>
                </template>
              </li>
            </ol>

            <!-- Claims Submit -->
            <div v-if="claimsSubmitCard">
              <!-- Total -->
              <ul id="item-list" class="collection vetting-soft-total">
                <li class="collection-item">
                  <span class="right">
                    <em>(Sent: ₦{{ totalSent(encounter) }})</em> |

                    {{ encounter.status == "p" ? "Vetted" : "Approved" }}:
                    <b><span :class="{
                      'red-text': encounter.status == 'p',
                      'green-text text-darken-2': encounter.status != 'p',
                    }">₦{{ totalApproved(encounter) }}</span></b>

                    <br />
                  </span>
                </li>
              </ul>

              

              <!-- Submit -->
              <template v-if="clusterStatus != 'v' && clusterStatus != 'r'">
                <div class="row vetting-soft-actions">
                <a class="waves-effect waves-light btn-large col s12 m2 left vetting-soft-back-action" @click.prevent="handleBack">
                  <i class="medium material-icons left">chevron_left</i>Back
                </a>

                <!-- Breaker -->
                <span class="co1 m4"></span>

                  <a class="waves-effect waves-light btn-large col s12 m3 right vetting-soft-next-action" :class="{ green: encounter.status == 'p' }"
                  @click.prevent="handleNext('approve')">
                  <i class="large material-icons left">{{
                    encounter.status == "p" ? "check_circle" : "chevron_right"
                  }} </i>{{ encounter.status == "p" ? "Approve" : "Next" }}
                </a>

                <a class="waves-effect waves-light btn-large black col s12 m2 right" @click.prevent="handleEncounterForDelete(encounter)"
                  v-if="encounter.status != 'd'"><i class="medium material-icons left">clear</i>Reject</a>

                <a class="waves-effect waves-light btn-large black col s12 m2 right" @click.prevent="handleReVet(encounter)" v-else><i
                    class="medium material-icons left">refresh</i>Re-vet</a>
                </div>
              </template>

              <template v-else>
                <div class="row vetting-soft-actions">
                <a class="waves-effect waves-light btn-large disabled black col s12 m2 left"><i
                    class="medium material-icons left">clear</i>Reject</a>

                    <!-- Breaker -->
                <span class="co1 m7"></span>

                <a class="waves-effect waves-light btn-large col s12 m3 right" @click.prevent="handleBack"><i
                    class="large material-icons left">chevron_right</i>Okay</a>
                </div>    
              </template>
            </div>
          </div>

        </div>

        <!-- Edit Claims -->
        <div id="review" class="card vetting-soft-edit" :class="{ 'teal lighten-5': !error, 'red lighten-5': error }" v-if="claimsCard">

          <div class="card-content" v-if="deleteClaim">
            <form>
              <div class="row">
                <div class="input-field col s12 m8">
                  <input v-model="item" id="item" type="text" readonly />
                  <label class="active" for="item">Item</label>
                </div>
                <div class="input-field col s6 m2">
                  <input v-model="qty" id="delete_qty" type="number" disabled />
                  <label class="active" for="delete_qty">Quantity</label>
                </div>
                <div class="input-field col s6 m2">
                  <input v-model="amt" id="amt" type="number" disabled />
                  <label class="active" for="amt">Amount</label>
                </div>
                <div class="input-field col s12" v-if="deleteHolder">
                  <input v-model="comment" id="comment" type="text" required />
                  <label class="active teal-text" for="comment">Comment</label>
                </div>
              </div>
              <div class="row">
                <div class="input-field col s12">
                  <a class="waves-effect waves-light btn col s12 m2 left vetting-soft-back-action vetting-soft-close-action" @click.prevent="handleRefresh">
                    <i class="medium material-icons left">close</i>Close
                  </a>

                  <!-- Breaker -->
                  <span class="co1 m7"></span>

                  <button class="waves-effect waves-light btn red col s12 m3 right" @click.prevent="handleClaimDelete">
                    <i class="medium material-icons left">chevron_right</i>
                    Delete Item
                  </button>
                </div>
              </div>
            </form>
          </div>

          <div class="card-content" v-if="editClaim">
            <form>
              <div class="row" v-if="editHolder">
                <div class="input-field col s12">
                  <input v-model="comment" id="comment" type="text" />
                  <label class="active teal-text" for="comment">Comment</label>
                </div>
              </div>
              <div class="row" v-else>
                <div class="input-field col s12 m8">
                  <input v-model="item" id="item" type="text" readonly />
                  <label class="active" for="qty">Item</label>
                </div>
                <div class="input-field col s6 m2 teal lighten-5">
                  <input v-model="qty" @input="handlePricing" id="qty" type="number" />
                  <label class="active teal-text" for="qty">Quantity</label>
                </div>
                <div class="input-field col s6 m2">
                  <input v-model="amt" id="amt" type="number" readonly />
                  <label class="active" for="amt">Amount (Approval)</label>
                </div>
              </div>
              <div class="row">
                <div class="input-field col s12">
                  <a class="waves-effect waves-light btn col s12 m2 left vetting-soft-back-action vetting-soft-close-action" @click.prevent="handleRefresh">
                    <i class="medium material-icons left">close</i>Close
                  </a>

                <!-- Breaker -->
                <span class="co1 m7"></span>

                  <button class="waves-effect waves-light btn blue darken-2 col s12 m3 right" @click.prevent="handleClaimEdit">
                    <i class="medium material-icons left">chevron_right</i>
                    Edit Item
                  </button>
                </div>
              </div>
            </form>
          </div>

          <div class="card-content" v-if="deleteEncounter">
            <form>
              <div class="row">
                <div class="input-field col s12">
                  <input v-model="comment" id="comment" type="text" />
                  <label class="active teal-text" for="comment">Comment (Rejection Reason)</label>
                </div>
              </div>
              <div class="row">
                <div class="input-field col s12">
                  <a class="waves-effect waves-light btn black lighten-2 col s12 m2 left" @click.prevent="handleRefresh">
                    <i class="medium material-icons left">chevron_left</i>Back
                  </a>

                  <!-- Breaker -->
                  <span class="col m7"></span>

                  <button class="waves-effect waves-light btn red col s12 m3 right" @click.prevent="handleEncounterDelete">
                    <i class="medium material-icons left">highlight_off</i>
                    Confirm Reject
                  </button>
                </div>
              </div>
            </form>
          </div>

        </div>

      </div>
    </template>

    <div class="section center" v-if="!encounter">
      <h6>No Claims Encounter <em>found</em>...</h6>
    </div>
  </div>
</template>

<script>
import { ref, onMounted, computed, watchEffect, watch, nextTick } from "vue";
import postItem from "@/composables/postItem";
import LoadingDiv from "@/components/LoadingDiv.vue";
import AddClaimItem from "@/components/claim/AddClaimItemComponent.vue";
import { capitalizeFirstLetter, capWordsFx, } from "@/composables/fxLibrary/coreFx.js";
import {
  totalSentFx,
  totalApprovedFx,
} from "@/composables/calFunction/cal";
import M from "materialize-css";

export default {
  name: "VetClaimComponent",
  components: { LoadingDiv, AddClaimItem },
  props: ["forTariff", "clusterStatus", "cluster", "encounterId"],
  emits: ["vetted"],
  setup(props, context) {
    const response = ref(null);
    const responseAll = ref([]);
    const isLoading = ref(true);
    const error = ref(false);
    const curr = ref(0);
    const total = ref(0);
    const deleteClaim = ref(null);
    const deleteHolder = ref(false);
    const editClaim = ref(null);
    const editHolder = ref(false);
    const deleteEncounter = ref(null);
    const claimsCard = ref(false);
    const claimsDisplayCard = ref(true);
    const claimsSubmitCard = ref(true);
    const claimsList = ref([]);
    const item = ref(null);
    const qty = ref(null);
    const amt = ref(null);
    const standard = ref(null);
    const comment = ref(null);
    const adder = ref(null);

    // toolTip
    const toolTip = () => {
      var elems = document.querySelectorAll(".tooltipped");
      M.Tooltip.init(elems, {});
    };

    // restart toolTip
    const restartComments = () => {
      // load comment
      setTimeout(() => {
        toolTip();
      }, 2000);
    };

    // load after data loads and updates
    watchEffect(() => {
      if (response.value) {
        restartComments();
      }
    });

    //from functions
    const capWords = (val) => {
      return capWordsFx(val);
    };

    const claimStores = (claim) => {
      if (!claim?.stores) {
        return {};
      }

      if (typeof claim.stores === "string") {
        try {
          return JSON.parse(claim.stores) || {};
        } catch {
          return {};
        }
      }

      return claim.stores;
    };

    const hasClaimComment = (claim) => String(claim?.comment || "").trim().length > 0;

    const isMissingApprovalValue = (value) => value === null || value === undefined || value === "";

    const isLegacyOneProviderPlaceholder = (claim) => {
      const stores = claimStores(claim);
      const approvedQty = Number(claim?.approved_qty);
      const approvedPrice = Number(claim?.approved_price);
      const sentQty = Number(claim?.sent_qty);
      const sentPrice = Number(claim?.sent_price);

      return Boolean(stores?.oneprovider)
        && claim?.authorization === "n"
        && claim?.status === "a"
        && Number.isFinite(approvedQty)
        && Number.isFinite(approvedPrice)
        && approvedQty === 0
        && approvedPrice === 0
        && (sentQty > 0 || sentPrice > 0)
        && !hasClaimComment(claim);
    };

    const claimApprovalNeedsInitialization = (claim) => {
      return isMissingApprovalValue(claim?.approved_qty)
        || isMissingApprovalValue(claim?.approved_price)
        || isLegacyOneProviderPlaceholder(claim);
    };

    const claimNumbersMatch = (left, right) => {
      const leftNumber = Number(left);
      const rightNumber = Number(right);

      return Number.isFinite(leftNumber) && Number.isFinite(rightNumber)
        ? leftNumber === rightNumber
        : left === right;
    };

    const hasClaimVettingAdjustment = (claim) => {
      if (claimApprovalNeedsInitialization(claim)) {
        return false;
      }

      return !claimNumbersMatch(claim?.sent_qty, claim?.approved_qty)
        || !claimNumbersMatch(claim?.sent_price, claim?.approved_price);
    };

    const initializeClaimApproval = (claim) => {
      const sentQty = Number(claim.sent_qty);
      const sentPrice = Number(claim.sent_price);
      const standardPrice = Number(claim.standard_price);
      const standardTotal = Number.isFinite(standardPrice) && standardPrice > 0
        ? sentQty * standardPrice
        : null;

      claim.approved_qty = claim.sent_qty;

      if (standardTotal !== null && sentPrice > standardTotal) {
        claim.approved_price = standardTotal;
        claim.comment = "Over Billing";
      } else {
        claim.approved_price = claim.sent_price;
      }
    };

    // total calculations (sent)
    const totalSent = (encounter) => {
      return totalSentFx(encounter);
    };

    // total calculations (approved)
    const totalApproved = (encounter) => {
      return totalApprovedFx(encounter);
    };

    // next Unvetted
    onMounted(() => {
      if (props.cluster) {
        // start
        responseAll.value = props.cluster;
        // total
        total.value = responseAll.value.length;
        // next
        updateClusterData(responseAll.value);
      }
    });

    // starter
    const updateClusterData = (val) => {
      if (val) {
        // check if available for vetting
        val.forEach((x, y) => {
          if (x.id == props.encounterId) {
            // (seen) good to go
            response.value = x;
            // number
            curr.value = y + 1;
          }
        });
        if (!response.value) {
          // next
          handleNext("next");
        }
      }
      // end load
      isLoading.value = false;
    };

    // clear inputs
    const claimInputClear = () => {
      // hide show cards
      claimsCard.value = false;
      claimsSubmitCard.value = true;

      // clear all
      item.value = null;
      qty.value = null;
      amt.value = null;
      standard.value = null;
      comment.value = null;

      // clear delete (if needed)
      deleteClaim.value = null;
      // clear editHolder
      deleteHolder.value = false;
      // clear edit (if needed)
      editClaim.value = null;
      // clear editHolder
      editHolder.value = false;
      // clear encounter delete
      deleteEncounter.value = null;
      // clear error (if needed)
      error.value = false;

      // retart Comments
      restartComments();
    };

    const scrollToLocalSection = async (id) => {
      await nextTick();
      window.requestAnimationFrame(() => {
        const target = document.getElementById(id);
        if (!target) {
          return;
        }

        const top = target.getBoundingClientRect().top + window.scrollY - 18;
        window.scrollTo({ behavior: "smooth", top: Math.max(top, 0) });
      });
    };

    // watch
    // slide between review and display
    watch(item, (newValue) => {
      scrollToLocalSection(newValue ? "review" : "display");
    });

    // add new claim
    const handleAddClaim = () => {
      if (adder.value) {
        adder.value = false;
      } else {
        adder.value = true;
      }
      scrollToLocalSection("display");
    }

    // add only approved
    // sent set to zero
    const handleAddClaimUpdate = async (val) => {

      if (val?.id === 'clearClaim') {
          // recall handleClaim
          handleAddClaim();
      } 

      if (val?.id === 'addNewClaim') {

        // clear all errors first
        error.value = false;

        // update
        let newVal = {
          encounter_id: response.value.id,
          item: val.value.claim,
          sent_qty: 0,
          sent_price: 0,
          approved_qty: val.value.qty,
          approved_price: val.value.amt,
          standard_price: val.value.standard,
          comment: "New Item (added by HMO)",
          status: "a",
        };

        // post update
        const { res, err } = await postItem("claim", newVal);

        if (res.value) {
          // success
          response.value.claims.push({
            ...res.value.data,
          });

          //reset comments manually
          restartComments();

          // clear
          handleAddClaim();

        } else {
          error.value = err.value;
        }


      }


    }

    // edit claim
    const handleEdit = (claim) => {
      if (claim != editClaim.value) {
        // clear all
        claimInputClear();

        // hide show cards
        claimsCard.value = true;
        claimsSubmitCard.value = false;

        // for main
        editClaim.value = claim;
        item.value = claim.item;
        qty.value = claim.approved_qty;
        amt.value = claim.approved_price;
        standard.value = claim.standard_price;
      } else {
        // same item was clicked twice
        // clear all
        claimInputClear();
      }
    };

    // delete claim
    const handleDelete = (claim) => {
      if (claim != deleteClaim.value) {
        // clear all
        claimInputClear();

        // hide show cards
        claimsCard.value = true;
        claimsSubmitCard.value = false;

        // for main
        deleteClaim.value = claim;
        item.value = claim.item;
        qty.value = claim.sent_qty;
        amt.value = claim.sent_price;
        standard.value = claim.standard_price;
        comment.value = null;
        deleteHolder.value = true;
      } else {
        // same item was clicked twice
        // clear all
        claimInputClear();
      }
    };

    // prepare delete encounter
    const handleEncounterForDelete = (encounter) => {
      // clear all
      claimInputClear();

      // hide show cards
      claimsCard.value = true;
      claimsSubmitCard.value = false;

      // for main
      deleteEncounter.value = encounter;
    };

    // re-vet
    const handleReVet = (encounter) => {
      // clear all
      claimInputClear();

      // restore
      if (response.value == encounter) {
        response.value.claims.forEach((x) => {
          // all
          x.status = "a";
          x.approved_qty = null; // insurance (should be null already) // encounter computed will fix temp
          x.approved_price = null; // insurance (should be null already) // encounter computed will fix temp
          x.comment = null;

          // update authorization y,z with stores
          if (x.authorization !== "n") {
            x.approved_qty = x.stores?.approved_qty;
            x.approved_price = x.stores?.approved_price;
            x.comment = x.stores?.comment;
          }

        });
        response.value.status = "p"; // switch back to pending
      }
    };

    // reset claim
    const handleReset = (claim) => {
      // edit
      const index = response.value.claims.findIndex((x) => x.id === claim.id);
      if (index !== -1) {
        // claim status = a = active
        response.value.claims[index] = {
          ...response.value.claims[index],
          status: "a",
        };
        // encounter status = p = pending vetting
        response.value.status = "p";

        // clear entry
        claimInputClear();
      }
    };

    // load claims
    const handleClaimDelete = () => {
      if (deleteHolder.value && comment.value) {
        // edit
        const index = response.value.claims.findIndex(
          (x) => x.id === deleteClaim.value.id
        );
        if (index !== -1) {
          // claim status = d = delete
          response.value.claims[index] = {
            ...response.value.claims[index],
            approved_qty: null,
            approved_price: null,
            comment: comment.value,
            status: "d",
          };
          // encounter status = p = pending vetting
          response.value.status = "p";

          // clear entry
          claimInputClear();
        }
      } else {
        // input default
        comment.value = "Not applicable";
        deleteHolder.value = true;

        // reset error (if required)
        error.value = false;
      }
    };

    // load claims
    const handleClaimEdit = () => {
      // start action
      if (item.value && qty.value && amt.value) {
        if (
          (editHolder.value && comment.value) ||
          Number(amt.value) >= Number(editClaim.value.sent_price) // proceed to reload approved amounts if new amount exceeds sent amount // sent amount will be validated below with standard and qty
        ) {
          // format for saving
          const { fx } = capitalizeFirstLetter(item.value);

          if (editClaim.value) {
            // edit
            const index = response.value.claims.findIndex(
              (x) => x.id === editClaim.value.id
            );
            if (index !== -1) {
              // found record
              // check if amount is greater 
              // base price or sent price - whichever is smaller
              let baseAmount = response.value.claims[index].sent_qty * response.value.claims[index].standard_price;
              if (response.value.claims[index].sent_price < baseAmount) { baseAmount = response.value.claims[index].sent_price }
              // continue logic
              if (
                Number(amt.value) >
                Number(baseAmount)
              ) {
                // reload approved price & qty
                response.value.claims[index] = {
                  ...response.value.claims[index],
                  item: fx.value,
                  approved_qty: response.value.claims[index].approved_qty,
                  approved_price: response.value.claims[index].approved_price,
                  comment: null,
                };
              } else {
                // load vetted price & qty
                response.value.claims[index] = {
                  ...response.value.claims[index],
                  item: fx.value,
                  approved_qty: qty.value,
                  approved_price: amt.value,
                  comment: comment.value,
                };
              }
              // encounter status = p = pending vetting
              response.value.status = "p";
            }
          }

          // clear entry
          claimInputClear();

          // reset error (if required)
          error.value = false;
        } else {
          // input default
          if (editClaim.value.comment) {
            comment.value = editClaim.value.comment;
          } else {
            comment.value = "Over Prescription";
          }
          editHolder.value = true;

          // reset error (if required)
          error.value = false;
        }
      } else {
        error.value = true;
      }
    };

    // reject encounter
    const handleEncounterDelete = () => {
      if (deleteEncounter.value && comment.value) {

        // call handle next
        handleNext("reject");

      } else {
        // set error
        error.value = true;
      }
    };

    // watch qty & price
    const handlePricing = () => {
      amt.value = (Number(qty.value) * Number(standard.value)).toFixed(2);
    };

    // refresh field
    const handleRefresh = () => {
      // clear entry
      claimInputClear();
    };

    // handle back
    const handleBack = () => {
      // done
      context.emit("vetted", {
        status: "back",
      });
    };

    // handle approve
    const handleNext = async (val) => {
      // starter
      isLoading.value = true;

      // approve workflow
      if (val == "approve") {
        // start
        let newVal = {
          encounter: { id: response.value.id, status: "v" },
          claims: response.value.claims,
        };

        // post update
        const { res, err } = await postItem("claim/update/bulk", newVal);

        if (res.value) {
          // mark
          response.value.status = "v";
        } else {
          error.value = err.value;
        }
      }

      // reject workflow
      if (val == "reject") {
        // empty object
        let stores = {};
        // response copy
        let responseCopy = response.value;

        // decline responseCopy
        responseCopy.status = "d";

        // decline workflow
        responseCopy.claims.forEach((x) => {
          // keep authorization z and y in stores (for reference)
          if (x.authorization !== "n") {
            if (x.stores) { stores = x.stores }
            if (x.authorization === "y") { stores.approved_price = x.approved_price }
            stores.approved_qty = x.approved_qty;
            stores.comment = x.comment;
            // reload stores
            x.stores = stores;
          }
          // wholesale update
          x.approved_qty = null;
          x.approved_price = null;
          x.comment = comment.value;
          x.status = "d";
        });

        // start
        let newVal = {
          encounter: { id: responseCopy.id, status: responseCopy.status },
          claims: responseCopy.claims,
        };

        // post update
        const { res, err } = await postItem("claim/update/bulk", newVal);

        if (res.value) {
          // mark
          response.value = responseCopy;
        } else {
          error.value = err.value;
        }

      }

      // update
      if (val != "next") {
        // next is from onMounted!
        responseAll.value.forEach((x) => {
          if (x.id == response.value.id) {
            x = response.value; // update
          }
        });

        // clear regardless
        response.value = null;
      }

      // NEXT
      // CLAIM
      // SELECTED 
      // HERE
      responseAll.value.forEach((x, y) => {
        if (x.status === "p" && response.value?.status !== "p") {
          // good to go
          response.value = x;
          // number
          curr.value = y + 1;
        }
      });

      // route
      if (!response.value) {
        // done
        context.emit("vetted", {
          status: "success",
          value: responseAll.value,
        });
      }

      isLoading.value = false; // end
    };

    // output encounter results
    const encounter = computed(() => {
      if (!response.value) {
        return null;
      } else {
        // billing insurance 
        // (if everything else fails, this wont!)
        // for pending encounters only
        response.value.claims.forEach((x) => {
          if (x.status !== "d" && claimApprovalNeedsInitialization(x) && response.value.status === 'p') {
            initializeClaimApproval(x);
          }
        });

        return response.value;
      }
    });

    // check for empties
    watchEffect(() => {
      if (encounter.value) {
        if (!encounter.value?.claims?.length && encounter.value?.status === 'p') {
          // Next
          handleNext("approve");
        }
      }
    });

    return {
      capWords,
      hasClaimComment,
      hasClaimVettingAdjustment,
      handleAddClaimUpdate,
      handleAddClaim,
      handlePricing,
      handleEdit,
      handleReset,
      handleDelete,
      handleReVet,
      handleEncounterForDelete,
      handleEncounterDelete,
      handleClaimDelete,
      handleClaimEdit,
      handleRefresh,
      handleNext,
      handleBack,
      totalSent,
      totalApproved,
      curr,
      total,
      deleteClaim,
      deleteHolder,
      editClaim,
      editHolder,
      deleteEncounter,
      isLoading,
      error,
      claimsCard,
      claimsDisplayCard,
      claimsSubmitCard,
      claimsList,
      item,
      qty,
      amt,
      standard,
      comment,
      adder,
      encounter,
    };
  },
};
</script>

<style scoped>
.vetting-soft-core,
.vetting-soft-bio,
.vetting-soft-diagnosis,
.vetting-soft-claims,
.vetting-soft-edit,
.vetting-core-card,
.vetting-member-card,
.vetting-diagnosis-card,
.vetting-claims-card,
.vetting-edit-card,
.vetting-claim-item {
  animation: sbaSlideIn var(--sba-slide-duration, 260ms) ease-out both;
}

.vetting-soft-core {
  border: 1px solid #e1e8eb;
  border-radius: 6px;
  overflow: hidden;
}

.vetting-soft-core-add-open {
  overflow: visible;
}

.vetting-soft-bio {
  border-bottom: 1px solid #e1e8eb;
  margin: 0;
}

.vetting-soft-count {
  border-radius: 6px;
  padding-bottom: 8px !important;
  padding-top: 8px !important;
}

.vetting-soft-flag {
  border: 1px solid #ffe082;
  border-radius: 6px;
  margin-bottom: 0;
}

.vetting-soft-diagnosis {
  border-bottom: 1px solid #e1e8eb;
  margin-bottom: 0;
}

.vetting-soft-diagnosis .card-content {
  border-radius: 0;
  padding-bottom: 14px;
  padding-top: 14px;
}

.vetting-soft-claims {
  border: 0;
  box-shadow: none;
  margin: 12px 0 0;
}

.vetting-soft-add {
  border: 1px solid rgba(0, 137, 123, 0.18);
}

.vetting-soft-add-panel {
  padding: 16px 24px 0;
  position: relative;
  z-index: 10;
}

.vetting-soft-add-panel :deep(.card) {
  background: #ffffff !important;
  border: 1px solid #e1e8eb;
  border-radius: 6px;
  box-shadow: none !important;
  margin: 0;
  overflow: hidden;
  width: 100%;
}

.vetting-soft-add-panel :deep(.card.teal.lighten-5) {
  background-color: #ffffff !important;
}

.vetting-soft-add-panel :deep(.card.red.lighten-5) {
  background-color: #fff8f8 !important;
}

.vetting-soft-add-panel :deep(.card-content) {
  padding: 18px 22px 14px;
}

.vetting-soft-add-panel :deep(.row) {
  margin-bottom: 8px;
}

.vetting-soft-add-panel :deep(.input-field) {
  margin-bottom: 8px;
  margin-top: 8px;
}

.vetting-soft-add-panel :deep(.add-claim-item-card),
.vetting-soft-add-panel :deep(.add-claim-item-card .card-content),
.vetting-soft-add-panel :deep(.add-claim-item-card form),
.vetting-soft-add-panel :deep(.add-claim-item-card .row),
.vetting-soft-add-panel :deep(.add-claim-item-card .input-field) {
  overflow: visible !important;
}

.vetting-soft-add-panel :deep(.add-claim-item-card) {
  position: relative;
  z-index: 20;
}

.vetting-soft-add-panel :deep(.add-claim-item-card .autocomplete-content.dropdown-content) {
  max-height: 320px;
  overflow-y: auto;
  z-index: 1200;
}

.vetting-soft-add-panel :deep(.btn-large) {
  height: 40px;
  line-height: 40px;
  padding: 0 20px;
}

.vetting-soft-add-panel :deep(.btn-large i) {
  font-size: 1.25rem;
  line-height: 40px;
}

.vetting-soft-list {
  border-color: #e1e8eb;
  border-radius: 6px;
  overflow: hidden;
}

.vetting-soft-list .collection-item {
  border-bottom-color: #edf2f4;
  line-height: 1.48;
}

.vetting-soft-list .claim-line-item {
  box-sizing: border-box;
  min-height: 54px;
  padding-right: 126px;
  position: relative;
}

.vetting-soft-list .claim-line-copy {
  display: block;
  max-width: 100%;
  min-width: 0;
  overflow-wrap: break-word;
}

.vetting-soft-list .line-item-actions {
  align-items: center;
  display: inline-flex;
  gap: 6px;
  justify-content: flex-end;
  position: absolute;
  right: 24px;
  top: 50%;
  transform: translateY(-50%);
  white-space: nowrap;
}

.vetting-soft-list .line-item-actions .secondary-content {
  float: none;
  margin-left: 0;
  position: static;
}

.vetting-soft-list .line-item-actions a {
  align-items: center;
  border-radius: 50%;
  display: inline-flex;
  height: 30px;
  justify-content: center;
  position: relative;
  width: 30px;
}

.vetting-soft-list .line-item-actions a + a::before {
  background: #c4d3d9;
  content: "";
  height: 20px;
  left: -3px;
  position: absolute;
  top: 5px;
  width: 1px;
}

.vetting-soft-list .line-item-actions i {
  line-height: 1;
}

.vetting-soft-list .collection-item:nth-child(even) {
  background: #fbfcfc;
}

.vetting-soft-total {
  border-color: #d9e1e5;
  border-radius: 6px;
  overflow: hidden;
}

.vetting-soft-total .collection-item {
  background: #f8fafb;
  border-bottom: 0;
}

.vetting-soft-actions {
  margin-top: 24px;
  margin-bottom: 0;
}

.vetting-soft-back-action {
  background: #ffffff;
  border: 1px solid #c4d3d9;
  box-shadow: none;
  color: #455a64;
  margin-left: 10px;
}

.vetting-soft-back-action:hover,
.vetting-soft-back-action:focus {
  background: #f8fafb;
  box-shadow: 0 8px 18px -18px rgba(38, 50, 56, 0.72);
  color: #263238;
}

.vetting-soft-close-action {
  background: #ffffff;
  border: 1px solid #c4d3d9;
  box-shadow: 0 6px 14px -12px rgba(38, 50, 56, 0.75);
  color: #455a64;
}

.vetting-soft-close-action:hover,
.vetting-soft-close-action:focus {
  background: #f8fafb;
  box-shadow: 0 8px 18px -18px rgba(38, 50, 56, 0.72);
  color: #263238;
}

.vetting-soft-close-action i {
  color: inherit;
}

.vetting-soft-next-action {
  margin-left: 10px;
}

.vetting-soft-edit {
  border: 1px solid #d9e1e5;
  border-radius: 6px;
}

.vetting-core-card {
  background: #ffffff;
  border: 1px solid #d9e1e5;
  border-radius: 6px;
  box-shadow: 0 12px 22px -24px rgba(38, 50, 56, 0.65);
  overflow: hidden;
}

.vetting-member-card {
  align-items: center;
  background: #ffffff;
  border-bottom: 1px solid #e1e8eb;
  display: flex;
  gap: 18px;
  justify-content: space-between;
  padding: 22px 24px;
}

.vetting-member-card.is-deleted {
  background: #fff7f7;
}

.vetting-member-main {
  align-items: center;
  display: flex;
  gap: 16px;
  min-width: 0;
}

.vetting-step-chip {
  align-items: baseline;
  background: #f8fafb;
  border: 1px solid #cfd8dc;
  border-radius: 6px;
  color: #263238;
  display: inline-flex;
  flex: 0 0 auto;
  font-weight: 900;
  gap: 2px;
  min-width: 54px;
  padding: 8px 10px;
}

.vetting-step-chip span {
  font-size: 1.05rem;
}

.vetting-step-chip small {
  color: #78909c;
  font-weight: 800;
}

.vetting-member-copy {
  min-width: 0;
}

.vetting-member-copy > p {
  color: #607d8b;
  font-size: 0.82rem;
  font-weight: 700;
  margin: 0 0 4px;
}

.vetting-member-copy h5 {
  color: #263238;
  font-size: 1.38rem;
  font-weight: 800;
  line-height: 1.2;
  margin: 0;
}

.vetting-enrollee-number {
  color: #455a64;
  display: inline-flex;
  font-size: 0.88rem;
  font-weight: 700;
  margin-top: 5px;
}

.vetting-date-line {
  align-items: center;
  color: #455a64;
  display: flex;
  flex-wrap: wrap;
  font-size: 0.84rem;
  font-weight: 700;
  gap: 7px;
  margin: 8px 0 0;
}

.vetting-date-line i {
  color: #90a4ae;
  font-size: 16px;
}

.vetting-date-line.is-muted {
  color: #78909c;
}

.vetting-member-photo img {
  border: 3px solid #ffffff;
  box-shadow: 0 9px 18px -16px rgba(38, 50, 56, 0.8);
  display: block;
  height: 74px;
  object-fit: cover;
  width: 74px;
}

.vetting-flag-note {
  background: #fff8e1;
  border: 1px solid #ffd54f;
  border-radius: 6px;
  color: #5d4037;
  flex: 0 0 250px;
  padding: 10px 12px;
}

.vetting-flag-note label {
  align-items: center;
  color: #bf7200;
  display: flex;
  font-weight: 900;
  gap: 5px;
  text-transform: uppercase;
}

.vetting-flag-note p {
  margin: 4px 0 0;
}

.vetting-diagnosis-card {
  align-items: center;
  background: #f8fafb;
  border-bottom: 1px solid #e1e8eb;
  display: flex;
  gap: 12px;
  padding: 15px 24px;
}

.vetting-diagnosis-icon {
  align-items: center;
  background: #ffffff;
  border: 1px solid #d9e1e5;
  border-radius: 50%;
  color: #00897b;
  display: inline-flex;
  flex: 0 0 auto;
  height: 36px;
  justify-content: center;
  width: 36px;
}

.vetting-diagnosis-icon i {
  font-size: 19px;
}

.vetting-diagnosis-card span {
  color: #607d8b;
  display: block;
  font-size: 0.76rem;
  font-weight: 900;
  text-transform: uppercase;
}

.vetting-diagnosis-card p {
  color: #263238;
  font-weight: 800;
  line-height: 1.35;
  margin: 2px 0 0;
}

.vetting-claims-card {
  background: #ffffff;
}

.vetting-claims-content {
  padding: 20px 24px 22px;
}

.vetting-claims-title {
  align-items: center;
  display: flex;
  gap: 12px;
  justify-content: space-between;
  margin-bottom: 14px;
}

.vetting-claims-title span {
  color: #263238;
  display: block;
  font-size: 1.05rem;
  font-weight: 900;
}

.vetting-claims-title small {
  color: #78909c;
  display: block;
  font-weight: 700;
  margin-top: 2px;
}

.vetting-add-claim-action {
  align-items: center;
  background: #e0f2f1;
  border: 1px solid #80cbc4;
  border-radius: 50%;
  color: #00695c;
  cursor: pointer;
  display: inline-flex;
  flex: 0 0 auto;
  height: 36px;
  justify-content: center;
  width: 36px;
}

.vetting-add-claim-action.is-open {
  background: #fff3e0;
  border-color: #ffcc80;
  color: #e65100;
}

.vetting-add-claim-action i {
  font-size: 20px;
}

.vetting-claim-list {
  border: 1px solid #e1e8eb;
  border-radius: 6px;
  counter-reset: vetting-claims;
  margin: 0;
  overflow: hidden;
  padding: 0;
}

.vetting-claim-item {
  background: #ffffff;
  border-bottom: 1px solid #edf2f4;
  color: #37474f;
  counter-increment: vetting-claims;
  line-height: 1.55;
  list-style: none;
  min-height: 48px;
  padding: 13px 92px 13px 48px;
  position: relative;
}

.vetting-claim-item::before {
  color: #90a4ae;
  content: counter(vetting-claims, decimal-leading-zero);
  font-size: 0.72rem;
  font-weight: 900;
  left: 16px;
  position: absolute;
  top: 16px;
}

.vetting-claim-item:nth-child(even) {
  background: #fbfcfc;
}

.vetting-claim-item:last-child {
  border-bottom: 0;
}

.vetting-claim-item.is-adjusted {
  background: #fffaf0;
}

.vetting-claim-item.is-deleted {
  background: #f7f8f9;
  color: #78909c;
}

.vetting-claim-item.is-locked {
  border-left: 3px solid #90a4ae;
}

.vetting-claim-item :deep(.secondary-content),
.vetting-claim-item .secondary-content {
  margin-left: 8px;
}

.vetting-total-bar {
  align-items: center;
  background: #f8fafb;
  border: 1px solid #d9e1e5;
  border-radius: 6px;
  display: flex;
  justify-content: flex-end;
  margin-top: 14px;
  padding: 12px 14px;
}

.vetting-total-bar.is-legacy-total {
  list-style: none;
}

.vetting-total-bar li {
  list-style: none;
  width: 100%;
}

.vetting-total-bar .right {
  color: #455a64;
  display: block;
  float: none !important;
  font-weight: 700;
  text-align: right;
}

.vetting-action-row {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  justify-content: space-between;
  margin-top: 24px;
}

.vetting-action-btn {
  align-items: center;
  border: 1px solid transparent;
  border-radius: 6px;
  cursor: pointer;
  display: inline-flex;
  font-size: 0.86rem;
  font-weight: 900;
  gap: 8px;
  min-height: 42px;
  padding: 0 16px;
  text-transform: uppercase;
}

.vetting-action-btn i {
  font-size: 18px;
}

.vetting-action-btn.is-danger {
  background: #ffffff;
  border-color: #b0bec5;
  color: #c62828;
}

.vetting-action-btn.is-secondary {
  background: #ffffff;
  border-color: #b0bec5;
  color: #263238;
}

.vetting-action-btn.is-primary {
  background: #263238;
  border-color: #263238;
  color: #ffffff;
  margin-left: auto;
}

.vetting-action-btn.is-primary.is-approve {
  background: #00695c;
  border-color: #004d40;
}

.vetting-action-btn.disabled {
  cursor: default;
  opacity: 0.45;
  pointer-events: none;
}

.vetting-edit-card {
  background: #f8fafb;
  border: 1px solid #d9e1e5;
  border-radius: 6px;
  margin: 14px 24px 24px;
}

.vetting-edit-card.has-error {
  background: #fff7f7;
  border-color: #ffcdd2;
}

.vetting-edit-card .card-content {
  padding: 20px;
}

.spacer10 {
  margin-top: 10px;
  margin-bottom: 10px;
  margin-right: 10px;
  margin-left: 10px;
}

.custom-hr {
  width: 50%;
  /* Adjust the width as needed */
  border: none;
  border-top: 2px solid #ccc;
  /* Adjust the color and style as needed */
  margin: 20px 20px;
  /* Adjust margin as needed */
}

.counter {
  display: block;
  padding: 0.5em;
  /* Adjust padding to your liking */
  /* font-size: 1em;  Adjust font size */
}

.clickable {
  cursor: pointer;
  opacity: 1;
  /* Default opacity */
  transition: opacity 0.3s ease;
  /* Smooth opacity change */
}

.clickable:hover {
  opacity: 0.8;
  /* Slightly reduced opacity on hover */
}

.pointable {
  cursor: default;
  /* opacity: 1; Default opacity */
  /* transition: opacity 0.3s ease;  Smooth opacity change */
}

/* .pointable:hover {
    opacity: 0.8; Slightly reduced opacity on hover
  } */

@media only screen and (max-width: 992px) {
  .vetting-soft-list .claim-line-item {
    padding-right: 20px;
  }

  .vetting-soft-list .line-item-actions {
    background: #f8fafb;
    border: 1px solid #dbe5e9;
    border-radius: 999px;
    box-shadow: 0 8px 18px -18px rgba(38, 50, 56, 0.72);
    gap: 10px;
    margin-left: 10px;
    margin-top: 10px;
    padding: 4px;
    position: static;
    transform: none;
    width: max-content;
  }

  .vetting-soft-list .claim-line-copy .info-item:not(.secondary-content) {
    display: inline-flex;
    margin-right: 10px;
    position: relative;
    top: -0.35em;
    vertical-align: super;
  }

  .vetting-soft-list .claim-line-copy .info-item:not(.secondary-content) i {
    line-height: 1;
  }

  .vetting-soft-list .line-item-actions a {
    height: 34px;
    width: 34px;
  }

  .vetting-soft-list .line-item-actions a + a::before {
    display: none;
  }

  .vetting-soft-list .line-item-actions .tiny.material-icons {
    font-size: 1.25rem;
  }
}

@media only screen and (max-width: 700px) {
  .vetting-member-card,
  .vetting-member-main,
  .vetting-claims-title,
  .vetting-action-row {
    align-items: flex-start;
    flex-direction: column;
  }

  .vetting-member-card {
    padding: 18px;
  }

  .vetting-member-photo img {
    height: 64px;
    width: 64px;
  }

  .vetting-flag-note {
    flex-basis: auto;
    width: 100%;
  }

  .vetting-diagnosis-card,
  .vetting-claims-content {
    padding-left: 18px;
    padding-right: 18px;
  }

  .vetting-claim-item {
    padding-right: 16px;
  }

  .vetting-action-btn,
  .vetting-action-btn.is-primary {
    justify-content: center;
    margin-left: 0;
    width: 100%;
  }
}

@media (prefers-reduced-motion: reduce) {
  .vetting-soft-core,
  .vetting-soft-bio,
  .vetting-soft-diagnosis,
  .vetting-soft-claims,
  .vetting-soft-edit,
  .vetting-core-card,
  .vetting-member-card,
  .vetting-diagnosis-card,
  .vetting-claims-card,
  .vetting-edit-card,
  .vetting-claim-item {
    animation: none;
  }
}
</style>
